import React from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import useCurrentUser from "data/advisor/useCurrentUser";

import { FeatureFlagProvider } from "components/FeatureFlag";
import Loading from "components/Loading";

import { useSignUpVersion } from "scenes/Authentication/components/SignUpVersion";
import Modals from "scenes/Modals";
import NewUserModal from "scenes/Modals/components/Integrations/NewUserModal";

import { HublyRoutes, OnboardingRoutes } from "./authenticated";

function AuthenticatedRoutes() {
  const user = useCurrentUser();
  const signUpVersion = useSignUpVersion();
  const location = useLocation();

  if (!user?.id) {
    return (
      <Loading
        active
        messages={["Loading your workspace", "Loading your workflows"]}
      />
    );
  }

  return (
    <FeatureFlagProvider advisor={user}>
      <Switch>
        {(user?.setupComplete || user?.connectCrm) && (
          <Route path="/hub">
            <HublyRoutes />
          </Route>
        )}

        {!user?.setupComplete &&
          (signUpVersion === "v2" && !user?.connectCrm ? (
            <Route path="/onboarding">
              <OnboardingRoutes />
            </Route>
          ) : (
            <NewUserModal advisor={user} />
          ))}

        <Route>
          <Redirect
            to={{
              ...location,
              pathname: !user?.setupComplete ? "/onboarding" : "/hub",
            }}
          />
        </Route>
      </Switch>

      <Modals />
    </FeatureFlagProvider>
  );
}

AuthenticatedRoutes.propTypes = {};

AuthenticatedRoutes.defaultProps = {};

export default AuthenticatedRoutes;
